export const Services_Data=[
    {
        s_no:"01",
        s_name:"web design",
        s_desc:"I craft visually appealing and user-friendly website designs that blend creativity with functionality. Whether you're a business, startup, or personal brand, I focus on creating responsive layouts, intuitive navigation, and a seamless user experience to help your online presence stand out."
    },
    {
        s_no:"02",
        s_name:" Bootstrap web design",
        s_desc:"I design responsive and modern websites using the power of Bootstrap — a popular front-end framework. My focus is on clean layout, mobile-first design, and fast-loading pages. Whether it's a business site, portfolio, or landing page, I ensure cross-browser compatibility and a seamless user experience across all devices."
    },
    {
        s_no:"03",
        s_name:"Backend Services",
        s_desc:"I develop secure and scalable backend systems that power modern web applications. From database design and API development to authentication and server-side logic, I ensure smooth data flow and reliable performance using technologies like PHP, MySQL, and more."
    },
    {
        s_no:"04",
        s_name:"React JS",
        s_desc:"I build dynamic, responsive, and high-performance web applications using React.js. With reusable components and efficient state management, I ensure fast loading, smooth user interactions, and scalable frontend architecture tailored to your needs."
    },
    
];
